import { render } from "./News7.vue?vue&type=template&id=750641b8"
import script from "./News7.vue?vue&type=script&lang=js"
export * from "./News7.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__